import React from "react";

function SummerSpecial() {
  return (
    <div className="page-container">
      <h2>☀️ Summer Special Destinations</h2>
      <p>
        Beat the heat with our top summer picks. These destinations are safe,
        refreshing, and perfect for your sunny holidays.
      </p>
      <p>
        ✅ Switzerland – cool alpine weather & scenic lakes  
        ✅ Bali – beach paradise with cultural vibes  
        ✅ Maldives – crystal-clear waters, perfect for relaxation
      </p>
      <p>
        Whether you want mountains, beaches, or islands, our summer specials
        are designed to keep you cool and happy!
      </p>
      <img
        src="https://images.unsplash.com/photo-1507525428034-b723cf961d3e"
        alt="Summer vacation beach"
        style={{ width: "100%", borderRadius: "12px", marginTop: "20px" }}
      />
    </div>
  );
}

export default SummerSpecial;
